__turbopack_context__.v({
  "className": "caesar_dressing_5a89c010-module__9n4qTW__className",
});
